import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AppTooltip } from '@/components/ui/app-tooltip';
import { Icon } from '@/components/ui/icon';
import { Alert01IconSolid, Alert02Icon } from '@/components/ui/icon/glyphs';
import type { ComparisonMetric } from './resolution-integrity-types';

// Colour alone must not carry the flag (WCAG 1.4.1). Outline = the measure lowered the
// score; solid = a lopsided holder. The tooltip says why the value is marked.
export function WarningMarker(t0) {
  const $ = _c(17);
  const {
    metric,
    flagged
  } = t0;
  const t = useTranslations("market.resolutionIntegrity");
  let t1;
  if ($[0] !== flagged || $[1] !== metric || $[2] !== t) {
    t1 = flagged ? t("flagReason", {
      metric
    }) : t("lopsidedReason");
    $[0] = flagged;
    $[1] = metric;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = flagged ? Alert02Icon : Alert01IconSolid;
  let t3;
  if ($[4] !== t2) {
    t3 = <Icon icon={t2} aria-hidden={true} className="size-3.5" />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== flagged || $[7] !== t) {
    t4 = flagged ? t("loweredScore") : t("lopsidedHolder");
    $[6] = flagged;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <span className="sr-only">{t4}</span>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <button type="button" data-testid="resolution-integrity-warning" className="inline-flex shrink-0 cursor-help self-center text-feedback-warning-content">{t3}{t5}</button>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <AppTooltip content={t1} side="top" contentClassName="max-w-64">{t6}</AppTooltip>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}